module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Hansel&GretelWitchHunters.50b7e0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Hansel&GretelWitchHunters.jpg
// module id = dETr
// module chunks = 0